import {
    Col,
    DatePicker,
    Form,
    Input,
    Row,
    Select,
    Space,
} from 'antd';
import { AddressState, totemOptions } from '../states';
import { BILLING_TYPE } from '@/pages/Users/ShopManagerV2/BillingData/components/BillingForm/const';

const BILLING_TYPE_OPTIONS = [{ label: 'Todos', value: null }, ...BILLING_TYPE];

const STORE_SALES_FILTER_OPTIONS = [
    { label: 'Todos', value: '' },
    { label: 'Possui vendas', value: true },
    { label: 'Não possui vendas', value: false },
];

export const FilterStoreManagement = () => {
    return (
        <>
            <Row gutter={[20, 0]} className="clear-margin">
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item label="Cidade" name="city">
                        <Space direction="vertical" style={{ width: '100%' }}>
                            <Input />
                        </Space>
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item label="Estado" name="state">
                        <Select
                            options={AddressState}
                            showSearch
                            optionFilterProp="children"
                            filterOption={(input, option) =>
                                (option?.label ?? '').includes(
                                    input.toUpperCase(),
                                )
                            }
                            filterSort={(optionA, optionB) =>
                                (optionA?.label ?? '')
                                    .toLowerCase()
                                    .localeCompare(
                                        (optionB?.label ?? '').toLowerCase(),
                                    )
                            }
                        />
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item label="Totem" name="totemEnum">
                        <Select options={totemOptions} />
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item label="Ativa" name="active">
                        <Select
                            options={[
                                { label: 'Sim', value: true },
                                { label: 'Não', value: false },
                            ]}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[20, 0]} className="clear-margin">
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item label="Aberta" name="open">
                        <Select
                            options={[
                                { label: 'Sim', value: true },
                                { label: 'Não', value: false },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item
                        label="Totem Autenticado na PagBank"
                        name="isTotemAuthenticated"
                    >
                        <Select
                            options={[
                                { label: 'Sim', value: true },
                                { label: 'Não', value: false },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item label="Tipo de loja" name="inventory">
                        <Select
                            mode="multiple"
                            options={[
                                {
                                    label: 'Loja com estoque físico',
                                    value: 'store-physical',
                                },
                                {
                                    label: 'Não definido',
                                    value: 'null',
                                },
                                {
                                    label: 'Armazém com estoque físico',
                                    value: 'warehouse-physical',
                                },
                                {
                                    label: 'Estoque virtual',
                                    value: 'virtual',
                                },
                            ]}
                        />
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item
                        label="Mês de primeira venda"
                        name="firstSaleDate"
                    >
                        <DatePicker
                            format="YYYY/MM"
                            picker="month"
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item label="Tipo de cobrança" name="billingType">
                        <Select options={BILLING_TYPE_OPTIONS} />
                    </Form.Item>
                </Col>
                <Col
                    className="gutter-row"
                    xs={{ span: 24 }}
                    sm={{ span: 12 }}
                    md={{ span: 6 }}
                >
                    <Form.Item
                        label="Vendas nos últimos 7 dias"
                        name="saleInLastSevenDays"
                    >
                        <Select options={STORE_SALES_FILTER_OPTIONS} />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};
